import styled from "styled-components";

const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${props => (props.margin ? props.margin : "0.8rem")};
`;

export default Row;
